import { render } from "./TeamView.vue?vue&type=template&id=b27cb202&ts=true"
import script from "./TeamView.vue?vue&type=script&lang=ts"
export * from "./TeamView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Admin/Teams/TeamView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b27cb202"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b27cb202', __exports__)) {
    api.reload('b27cb202', __exports__)
  }
  
  module.hot.accept("./TeamView.vue?vue&type=template&id=b27cb202&ts=true", () => {
    api.rerender('b27cb202', render)
  })

}


export default __exports__